// import React, { useState, useEffect } from "react";
// import { z } from "zod";
// import { FaSearch, FaTimes, FaEdit, FaTrash } from "react-icons/fa";
// import Tabs from "./Tabs";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// // Define the role schema for validation
// const roleSchema = z.object({
//   roleName: z.string().min(3, "Role name must be at least 3 characters long."),
//   description: z
//     .string()
//     .min(5, "Description must be at least 5 characters long.")
//     .max(500, "Description must not exceed 500 characters."),
// });

// function AddRole() {
//   const [roleName, setRoleName] = useState("");
//   const [description, setDescription] = useState("");
//   const [errors, setErrors] = useState({});
//   const [roles, setRoles] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [currentRole, setCurrentRole] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchRoles();
//   }, []);

//   const fetchRoles = async () => {
//     try {
//       const userData = JSON.parse(localStorage.getItem("user"));
//       if (!userData || !userData.email) {
//         console.error("User not found in localStorage");
//         return;
//       }
//       const email = userData.email;

//       const response = await fetch(
//         `${AQ_BASE_URL}/aq/api/roles/getAllRoles?email=${encodeURIComponent(
//           email
//         )}`
//       );

//       if (response.ok) {
//         const data = await response.json();
//         setRoles(data);
//       } else {
//         console.error("Failed to fetch roles");
//       }
//     } catch (error) {
//       console.error("Error fetching roles:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddRole = async () => {
//     const validationResult = roleSchema.safeParse({ roleName, description });

//     if (!validationResult.success) {
//       const errorMessages = validationResult.error.errors.reduce(
//         (acc, err) => ({
//           ...acc,
//           [err.path[0]]: err.message,
//         }),
//         {}
//       );
//       setErrors(errorMessages);
//       return;
//     }

//     setErrors({});

//     try {
//       const response = await fetch(`${AQ_BASE_URL}/aq/api/roles/CreateRole`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({
//           role_name: roleName,
//           description: description,
//         }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         toast.success(`Role created successfully: ${data.role.role_name}`);
//         setRoleName("");
//         setDescription("");
//         fetchRoles(); // Refresh the roles list
//         setIsModalOpen(false);
//       } else {
//         const errorData = await response.json();
//         toast.error(`Error: ${errorData.message}`);
//       }
//     } catch (error) {
//       console.error("Error adding role:", error);
//       toast.error("Failed to add role. Please try again.");
//     }
//   };

//   const handleEditRole = (role) => {
//     setCurrentRole(role);
//     setRoleName(role.role_name);
//     setDescription(role.description);
//     setIsEditModalOpen(true);
//   };

//   const handleUpdateRole = async () => {
//     const validationResult = roleSchema.safeParse({ roleName, description });

//     if (!validationResult.success) {
//       const errorMessages = validationResult.error.errors.reduce(
//         (acc, err) => ({
//           ...acc,
//           [err.path[0]]: err.message,
//         }),
//         {}
//       );
//       setErrors(errorMessages);
//       return;
//     }

//     setErrors({});

//     try {
//       const userData = JSON.parse(localStorage.getItem("user"));
//       if (!userData || !userData.email) {
//         toast.error("User not found.");
//         return;
//       }

//       const response = await fetch(
//         `${AQ_BASE_URL}/aq/api/roles/updateRole/${
//           currentRole.id
//         }?email=${encodeURIComponent(userData.email)}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//           body: JSON.stringify({
//             role_name: roleName,
//             description: description,
//           }),
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//         toast.success(`Role updated successfully: ${data.role.role_name}`);
//         fetchRoles(); // Refresh the roles list
//         setIsEditModalOpen(false);
//         setCurrentRole(null);
//         setRoleName("");
//         setDescription("");
//       } else {
//         const errorData = await response.json();
//         toast.error(`Error: ${errorData.message}`);
//       }
//     } catch (error) {
//       toast.error("Failed to update role. Please try again.");
//     }
//   };

//   const handleDeleteRole = async (roleId) => {
//     if (!window.confirm("Are you sure you want to delete this role?")) {
//       return;
//     }

//     try {
//       const userData = JSON.parse(localStorage.getItem("user"));
//       if (!userData || !userData.email) {
//         toast.error("User not found.");
//         return;
//       }

//       const response = await fetch(
//         `${AQ_BASE_URL}/aq/api/roles/deleteRole/${roleId}?email=${encodeURIComponent(
//           userData.email
//         )}`,
//         {
//           method: "DELETE",
//           headers: {
//             Accept: "application/json",
//           },
//         }
//       );

//       if (response.ok) {
//         toast.success("Role deleted successfully");
//         fetchRoles(); // Refresh the roles list
//       } else {
//         const errorData = await response.json();
//         toast.error(`Error: ${errorData.message}`);
//       }
//     } catch (error) {
//       console.error("Error deleting role:", error);
//       toast.error("Failed to delete role. Please try again.");
//     }
//   };

//   const filteredRoles = roles.filter((role) =>
//     role.role_name.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <div className="p-4">
//       <Tabs />
//       <h1 className="text-xl font-bold mb-4 text-black">Manage Roles</h1>

//       <div className="flex items-center mb-6 space-x-4">
//         <div className="relative w-1/3">
//           <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
//           <input
//             type="text"
//             placeholder="Search roles"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full pl-10 pr-4 py-2 border-2 rounded-lg focus:outline-none"
//           />
//         </div>

//         <button
//           onClick={() => setIsModalOpen(true)}
//           className="bg-cyan-500 text-white px-6 py-2 rounded-lg"
//         >
//           Add Role
//         </button>
//       </div>

//       <h2 className="text-xl font-bold mt-8">Roles List</h2>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
//         {loading ? (
//           <div className="col-span-full text-left text-2xl text-gray-600">
//             Loading roles...
//           </div>
//         ) : filteredRoles.length === 0 ? (
//           <div className="col-span-full text-center text-lg text-gray-600">
//             No roles found.
//           </div>
//         ) : (
//           filteredRoles.map((role) => (
//             <div
//               key={role.id}
//               className="p-4 rounded-lg hover:shadow-lg bg-white relative"
//             >
//               <div className="absolute top-2 right-2 flex space-x-2">
//                 <button
//                   onClick={() => handleEditRole(role)}
//                   className="text-blue-500 hover:text-blue-700"
//                   title="Edit"
//                 >
//                   <FaEdit />
//                 </button>
//                 <button
//                   onClick={() => handleDeleteRole(role.id)}
//                   className="text-red-500 hover:text-red-700"
//                   title="Delete"
//                 >
//                   <FaTrash />
//                 </button>
//               </div>
//               <h3 className="font-bold text-lg">{role.role_name}</h3>
//               <p className="text-gray-600 text-sm">{role.description}</p>
//             </div>
//           ))
//         )}
//       </div>

//       {/* Add Role Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-8 rounded-lg w-1/3 shadow-lg relative">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Add Role</h2>
//             <button
//               onClick={() => setIsModalOpen(false)}
//               className="absolute top-4 right-4 text-red-500 hover:text-red-700 text-2xl"
//             >
//               <FaTimes />
//             </button>
//             <div className="mb-4">
//               <label className="block text-md font-medium text-gray-700 mb-1">
//                 Role Name
//               </label>
//               <input
//                 type="text"
//                 placeholder="Enter Role Name"
//                 value={roleName}
//                 onChange={(e) => setRoleName(e.target.value)}
//                 className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder:text-sm ${
//                   errors.roleName ? "border-red-500" : "border-gray-300"
//                 }`}
//               />
//               {errors.roleName && (
//                 <p className="text-red-500 text-sm mt-2">{errors.roleName}</p>
//               )}
//             </div>
//             <div className="mb-6">
//               <label className="block text-md font-medium text-gray-700 mb-1">
//                 Description
//               </label>
//               <textarea
//                 placeholder="Enter Description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//                 className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder::text-md ${
//                   errors.description ? "border-red-500" : "border-gray-300"
//                 }`}
//               ></textarea>
//               {errors.description && (
//                 <p className="text-red-500 text-sm mt-2">
//                   {errors.description}
//                 </p>
//               )}
//             </div>
//             <button
//               onClick={handleAddRole}
//               className="w-full bg-cyan-500 text-white px-1 py-2 rounded-md text-md font-semibold hover:text-black"
//             >
//               Add Role
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Edit Role Modal */}
//       {isEditModalOpen && (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
//           <div className="bg-white p-8 rounded-lg w-1/3 shadow-lg relative">
//             <h2 className="text-2xl font-bold text-gray-800 mb-6">Edit Role</h2>
//             <button
//               onClick={() => {
//                 setIsEditModalOpen(false);
//                 setCurrentRole(null);
//                 setRoleName("");
//                 setDescription("");
//               }}
//               className="absolute top-4 right-4 text-red-500 hover:text-red-700 text-2xl"
//             >
//               <FaTimes />
//             </button>
//             <div className="mb-4">
//               <label className="block text-md font-medium text-gray-700 mb-1">
//                 Role Name
//               </label>
//               <input
//                 type="text"
//                 placeholder="Enter Role Name"
//                 value={roleName}
//                 onChange={(e) => setRoleName(e.target.value)}
//                 className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder:text-sm ${
//                   errors.roleName ? "border-red-500" : "border-gray-300"
//                 }`}
//               />
//               {errors.roleName && (
//                 <p className="text-red-500 text-sm mt-2">{errors.roleName}</p>
//               )}
//             </div>
//             <div className="mb-6">
//               <label className="block text-md font-medium text-gray-700 mb-1">
//                 Description
//               </label>
//               <textarea
//                 placeholder="Enter Description"
//                 value={description}
//                 onChange={(e) => setDescription(e.target.value)}
//                 className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder::text-md ${
//                   errors.description ? "border-red-500" : "border-gray-300"
//                 }`}
//               ></textarea>
//               {errors.description && (
//                 <p className="text-red-500 text-sm mt-2">
//                   {errors.description}
//                 </p>
//               )}
//             </div>
//             <button
//               onClick={handleUpdateRole}
//               className="w-full bg-cyan-500 text-white px-1 py-2 rounded-md text-md font-semibold hover:text-black"
//             >
//               Update Role
//             </button>
//           </div>
//         </div>
//       )}
//       <ToastContainer className="mt-12" />
//     </div>
//   );
// }

// export default AddRole;

import React, { useState, useEffect } from 'react';
import { z } from 'zod';
import { FaSearch, FaTimes, FaEdit, FaTrash } from 'react-icons/fa';
import Tabs from './Tabs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// Define the role schema for validation
const roleSchema = z.object({
  roleName: z.string().min(3, 'Role name must be at least 3 characters long.'),
  description: z
    .string()
    .min(5, 'Description must be at least 5 characters long.')
    .max(500, 'Description must not exceed 500 characters.'),
});

function AddRole() {
  const [roleName, setRoleName] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [currentRole, setCurrentRole] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const response = await fetch(`${AQ_BASE_URL}/aq/api/currentuser`, {
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user data');
        }

        const userData = await response.json();
        if (userData && userData.email) {
          setEmail(userData.email);
          fetchRoles(userData.email);
        }
      } catch (error) {
        console.error('Failed to fetch user data:', error);
        toast.error('Failed to load user information');
        setLoading(false);
      }
    };

    fetchCurrentUser();
  }, []);

  const fetchRoles = async (userEmail) => {
    try {
      const response = await fetch(
        `${AQ_BASE_URL}/aq/api/roles/getAllRoles?email=${encodeURIComponent(userEmail)}`
      );

      if (response.ok) {
        const data = await response.json();
        setRoles(data);
      } else {
        console.error('Failed to fetch roles');
      }
    } catch (error) {
      console.error('Error fetching roles:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddRole = async () => {
    if (!email) {
      toast.error('User email not available');
      return;
    }

    const validationResult = roleSchema.safeParse({ roleName, description });

    if (!validationResult.success) {
      const errorMessages = validationResult.error.errors.reduce(
        (acc, err) => ({
          ...acc,
          [err.path[0]]: err.message,
        }),
        {}
      );
      setErrors(errorMessages);
      return;
    }

    setErrors({});

    try {
      const response = await fetch(
        `${AQ_BASE_URL}/aq/api/roles/CreateRole?email=${encodeURIComponent(email)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            role_name: roleName,
            description: description,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success(`Role created successfully: ${data.role.role_name}`);
        setRoleName('');
        setDescription('');
        fetchRoles(email); // Refresh the roles list
        setIsModalOpen(false);
      } else {
        const errorData = await response.json();
        toast.error(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error adding role:', error);
      toast.error('Failed to add role. Please try again.');
    }
  };

  const handleEditRole = (role) => {
    setCurrentRole(role);
    setRoleName(role.role_name);
    setDescription(role.description);
    setIsEditModalOpen(true);
  };

  const handleUpdateRole = async () => {
    if (!email) {
      toast.error('User email not available');
      return;
    }

    const validationResult = roleSchema.safeParse({ roleName, description });

    if (!validationResult.success) {
      const errorMessages = validationResult.error.errors.reduce(
        (acc, err) => ({
          ...acc,
          [err.path[0]]: err.message,
        }),
        {}
      );
      setErrors(errorMessages);
      return;
    }

    setErrors({});

    try {
      const response = await fetch(
        `${AQ_BASE_URL}/aq/api/roles/updateRole/${
          currentRole.id
        }?email=${encodeURIComponent(email)}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            role_name: roleName,
            description: description,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        toast.success(`Role updated successfully: ${data.role.role_name}`);
        fetchRoles(email); // Refresh the roles list
        setIsEditModalOpen(false);
        setCurrentRole(null);
        setRoleName('');
        setDescription('');
      } else {
        const errorData = await response.json();
        toast.error(`Error: ${errorData.message}`);
      }
    } catch (error) {
      toast.error('Failed to update role. Please try again.');
    }
  };

  const handleDeleteRole = async (roleId) => {
    if (!email) {
      toast.error('User email not available');
      return;
    }

    if (!window.confirm('Are you sure you want to delete this role?')) {
      return;
    }

    try {
      const response = await fetch(
        `${AQ_BASE_URL}/aq/api/roles/deleteRole/${roleId}?email=${encodeURIComponent(email)}`,
        {
          method: 'DELETE',
          headers: {
            Accept: 'application/json',
          },
        }
      );

      if (response.ok) {
        toast.success('Role deleted successfully');
        fetchRoles(email); // Refresh the roles list
      } else {
        const errorData = await response.json();
        toast.error(`Error: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error deleting role:', error);
      toast.error('Failed to delete role. Please try again.');
    }
  };

  const filteredRoles = roles.filter((role) =>
    role.role_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="p-4">
      <Tabs />
      <div className="py-4 px-6 bg-white h-screen rounded-md">
        <h1 className="text-xl font-bold mb-1 text-black">Manage Roles</h1>
        <p className="text-sm mb-4 text-gray-600">
          Manage roles effortlessly with simple add, edit, and delete controls
        </p>
        <div className="flex items-center mb-6 space-x-4">
          <div className="relative w-1/3">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
              type="text"
              placeholder="Search roles"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border-2 rounded-lg focus:outline-none"
            />
          </div>

          <button
            onClick={() => setIsModalOpen(true)}
            className="bg-black text-white px-6 py-2 rounded-lg"
          >
            Add Role
          </button>
        </div>

        <h2 className="text-xl font-bold mt-8">Roles List</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
          {loading ? (
            <div className="col-span-full text-left text-2xl text-gray-600">Loading roles...</div>
          ) : filteredRoles.length === 0 ? (
            <div className="col-span-full text-center text-lg text-gray-600">No roles found.</div>
          ) : (
            filteredRoles.map((role) => (
              <div key={role.id} className="p-4 rounded-lg hover:shadow-lg bg-gray-100 relative">
                <div className="absolute top-2 right-2 flex space-x-2">
                  <button
                    onClick={() => handleEditRole(role)}
                    className="text-blue-500 hover:text-blue-700"
                    title="Edit"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => handleDeleteRole(role.id)}
                    className="text-red-500 hover:text-red-700"
                    title="Delete"
                  >
                    <FaTrash />
                  </button>
                </div>
                <h3 className="font-bold text-lg">{role.role_name}</h3>
                <p className="text-gray-600 text-sm">{role.description}</p>
              </div>
            ))
          )}
        </div>

        {/* Add Role Modal */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-lg w-1/3 shadow-lg relative">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Add Role</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-red-500 hover:text-red-700 text-2xl"
              >
                <FaTimes />
              </button>
              <div className="mb-4">
                <label className="block text-md font-medium text-gray-700 mb-1">Role Name</label>
                <input
                  type="text"
                  placeholder="Enter Role Name"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                  className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder:text-sm ${
                    errors.roleName ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {errors.roleName && <p className="text-red-500 text-sm mt-2">{errors.roleName}</p>}
              </div>
              <div className="mb-6">
                <label className="block text-md font-medium text-gray-700 mb-1">Description</label>
                <textarea
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder::text-md ${
                    errors.description ? 'border-red-500' : 'border-gray-300'
                  }`}
                ></textarea>
                {errors.description && (
                  <p className="text-red-500 text-sm mt-2">{errors.description}</p>
                )}
              </div>
              <button
                onClick={handleAddRole}
                className="w-full bg-black text-white px-1 py-2 rounded-md text-md font-semibold hover:text-white"
              >
                Add Role
              </button>
            </div>
          </div>
        )}

        {/* Edit Role Modal */}
        {isEditModalOpen && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-lg w-1/3 shadow-lg relative">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Edit Role</h2>
              <button
                onClick={() => {
                  setIsEditModalOpen(false);
                  setCurrentRole(null);
                  setRoleName('');
                  setDescription('');
                }}
                className="absolute top-4 right-4 text-red-500 hover:text-red-700 text-2xl"
              >
                <FaTimes />
              </button>
              <div className="mb-4">
                <label className="block text-md font-medium text-gray-700 mb-1">Role Name</label>
                <input
                  type="text"
                  placeholder="Enter Role Name"
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                  className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder:text-sm ${
                    errors.roleName ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {errors.roleName && <p className="text-red-500 text-sm mt-2">{errors.roleName}</p>}
              </div>
              <div className="mb-6">
                <label className="block text-md font-medium text-gray-700 mb-1">Description</label>
                <textarea
                  placeholder="Enter Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className={`w-full px-3 py-2 border border-black rounded-md focus:outline-none placeholder::text-md ${
                    errors.description ? 'border-red-500' : 'border-gray-300'
                  }`}
                ></textarea>
                {errors.description && (
                  <p className="text-red-500 text-sm mt-2">{errors.description}</p>
                )}
              </div>
              <button
                onClick={handleUpdateRole}
                className="w-full bg-black text-white px-1 py-2 rounded-md text-md font-semibold hover:text-white"
              >
                Update Role
              </button>
            </div>
          </div>
        )}
        <ToastContainer className="mt-12" />
      </div>
    </div>
  );
}

export default AddRole;
